import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { MeetingType, MeetingLocation, MeetingRoom } from '../models/MasterMOM';
import { momDashboard, MeetingAppoinments, outlookAttendeeInsert, Attendees, GenInfoAtd, AttendeesAtd, FileAttachement, cmtObject, AgendaDetails, alert, meetingAction, meetingAction_DueToday, momDashboard_MyMeetings } from '../models/MOMForm';

import { saveAs } from 'file-saver';
import { usermaster, division, user } from '../models/admin';
import { Form } from '@angular/forms';
import { Users } from '../models/users';
@Injectable({
  providedIn: 'root'
})
export class MasterMOMService {
  // Define API
  apiURL = ''; //'http://localhost:59094/';
  constructor(private http: HttpClient) { }
  /*========================================
  CRUD Methods for consuming RESTful API
  =========================================*/
  // Http Options
  // Http Options
  private GetHttpOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.jwtToken()
      })
    }
  }
  httpOptions_file = {
    responseType: "text",
    headers: new HttpHeaders({
      'Authorization': 'Bearer ' + this.jwtToken()
    })
  };
  //Request API for Autherization to all the API call
  _requestTextAPI(url: string, body: any) {

    let headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.jwtToken() });
    let options = { headers: headers, responseType: 'text' as 'json' };
    return this.http.post(url, body, options)
  }
  private GetFileHttpOptions() {
    return {
      responseType: "blob",
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.jwtToken()
      })
    }
  }

  //JWT token access
  public jwtToken() {

    var struser = sessionStorage.getItem('accessinfo');
    if (struser) {
      let currentAccess = JSON.parse(struser);
      // create authorization header with jwt token           
      if (currentAccess && currentAccess.token) {
        //let headers = new Headers({ 'Authorization': 'Bearer ' + currentUser.token });
        return currentAccess.token;
      }
    }
  }


  //MeetingType//
  public getMeetingType(objMeetingType: MeetingType) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetMeetingType', objMeetingType, this.GetHttpOptions());
  }
  public addEditMeetingType(objMeetingType: MeetingType) {
    return this.http.post(this.apiURL + '/api/MasterMOM/InsertUpdateMeetingType', objMeetingType, this.GetHttpOptions());
  }
  public deleteMeetingType(objMeetingType: MeetingType) {
    return this.http.post(this.apiURL + '/api/MasterMOM/DeleteMeetingType', objMeetingType, this.GetHttpOptions());
  }


  //location//
  public getLocation(objMeetingLocation: MeetingLocation) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetLocation', objMeetingLocation, this.GetHttpOptions());
  }

  public addEditLocation(objMeetingLocation: MeetingLocation) {
    return this.http.post(this.apiURL + '/api/MasterMOM/InsertUpdateLocation', objMeetingLocation, this.GetHttpOptions());
  }
  public deleteLocation(objMeetingLocation: MeetingLocation) {
    return this.http.post(this.apiURL + '/api/MasterMOM/DeleteLocation', objMeetingLocation, this.GetHttpOptions());
  }


  //MeetingRoom//
  public getMeetingRoom(objMeetingRoom: MeetingRoom) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetMeetingRoom', objMeetingRoom, this.GetHttpOptions());
  }

  public addEditMeetingRoom(objMeetingRoom: MeetingRoom) {
    return this.http.post(this.apiURL + '/api/MasterMOM/InsertUpdateMeetingRoom', objMeetingRoom, this.GetHttpOptions());
  }
  public deleteMeetingRoom(objMeetingRoom: MeetingRoom) {
    return this.http.post(this.apiURL + '/api/MasterMOM/DeleteMeetingRoom', objMeetingRoom, this.GetHttpOptions());
  }
  public getDropMeetingLocation(objMeetingRoom: MeetingRoom) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetDropMeetingLocation', objMeetingRoom, this.GetHttpOptions());
  }




  SetTokenInfo_ByUserName(objusermaster: Users) { 
    return this._requestTextAPI('/api/Login/SetTokenInfo_ByUserName', objusermaster);  
  }
 

  //attendees//
  public getAttendees(objAttendees: Attendees) {

    return this.http.post(this.apiURL + '/api/MasterMOM/GetAttendees', objAttendees, this.GetHttpOptions());
  }
  public addEditAttendees(objAttendees: Attendees) {
    return this.http.post(this.apiURL + '/api/MasterMOM/InsertUpdateAttendees', objAttendees, this.GetHttpOptions());
  }
  public deleteAttendees(objAttendees: Attendees) {
    return this.http.post(this.apiURL + '/api/MasterMOM/DeleteAttendees', objAttendees, this.GetHttpOptions());
  }
  public InsertOutlookAttendees(inputVal: outlookAttendeeInsert) {
    return this.http.post(this.apiURL + '/api/MasterMOM/InsertOutlookAttendees', inputVal, this.GetHttpOptions());
  }

  public delAtdComment(inputVal: cmtObject) {

    return this.http.post(this.apiURL + '/api/MasterMOM/DelAtdComment', inputVal, this.GetHttpOptions());
  }
  public insertAtdComment(inputVal: cmtObject) {

    return this.http.post(this.apiURL + '/api/MasterMOM/InsertAtdComment', inputVal, this.GetHttpOptions());
  }
  public getAtdComment(inputVal: cmtObject) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetAtdComment', inputVal, this.GetHttpOptions());
  }

  public getGeneralInfoAtd(objGenInfoAtd: GenInfoAtd) {

    return this.http.post(this.apiURL + '/api/MasterMOM/GetGeneralInfomation', objGenInfoAtd, this.GetHttpOptions());
  }
  public getDelegateGeneralInfoAtd(objGenInfoAtd: GenInfoAtd) {

    return this.http.post(this.apiURL + '/api/MasterMOM/GetDelegateGeneralInfomation', objGenInfoAtd, this.GetHttpOptions());
  }

  public delGeneralInfoAtd(objGenInfoAtd: GenInfoAtd) {

    return this.http.post(this.apiURL + '/api/MasterMOM/DelGeneralInfoAtd', objGenInfoAtd, this.GetHttpOptions());
  }

  public publishGeneralInfo(objGenInfoAtd: GenInfoAtd) {

    return this.http.post(this.apiURL + '/api/MasterMOM/PublishGeneralInfoWeb', objGenInfoAtd, this.GetHttpOptions());
  }
  public attendancePublishGeneralInfo(objGenInfoAtd: GenInfoAtd) {

    return this.http.post(this.apiURL + '/api/MasterMOM/AttendancePublishGeneralInfo', objGenInfoAtd, this.GetHttpOptions());
  }

  public createFollowupMeeting(objGenInfoAtd: GenInfoAtd) {

    return this.http.post(this.apiURL + '/api/MasterMOM/CreateFollowupMeeting', objGenInfoAtd, this.GetHttpOptions());
  }

  public getMOMNumber(objGenInfoAtd: GenInfoAtd) {

    return this.http.post(this.apiURL + '/api/MasterMOM/GetMOMNumber', objGenInfoAtd, this.GetHttpOptions());
  }
  public addEditGeneralInfoAtd(objGenInfoAtd: GenInfoAtd) {
    return this.http.post(this.apiURL + '/api/MasterMOM/InsertUpdateGeneralInfoAtd', objGenInfoAtd, this.GetHttpOptions());
  }
  public deleteGeneralInfoAtd(objGenInfoAtd: GenInfoAtd) {
    return this.http.post(this.apiURL + '/api/MasterMOM/DeleteGeneralInfoAtd', objGenInfoAtd, this.GetHttpOptions());
  }
  public getMeetingTypedropsAtd(objGenInfoAtd: GenInfoAtd) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetDropMeetingTypeAtd', objGenInfoAtd, this.GetHttpOptions());
  }
  public getDropMeetingLocationAtd(objGenInfoAtd: GenInfoAtd) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetDropMeetingLocationAtd', objGenInfoAtd, this.GetHttpOptions());
  }
  public getDropMeetingRoomsAtd(objGenInfoAtd: GenInfoAtd) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetDropMeetingRoomAtd', objGenInfoAtd, this.GetHttpOptions());
  }

  //AttendeesAtd
  public getAttendeesAtd(objAttendeesAtd: AttendeesAtd) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetAttendeesAtd', objAttendeesAtd, this.GetHttpOptions());
  }

  public getAttendeDD(objAttendeesAtd: AttendeesAtd) {

    return this.http.post(this.apiURL + '/api/MasterMOM/GetAttendeesAtd', objAttendeesAtd, this.GetHttpOptions());
  }

  public getGeneralInfoDetails(objAttendeesAtd: AttendeesAtd) {

    return this.http.post(this.apiURL + '/api/MasterMOM/getGeneralInfoDetails', objAttendeesAtd, this.GetHttpOptions());
  }
  public AttendeColumnUpdate(objAttendeesAtd: AttendeesAtd) {

    return this.http.post(this.apiURL + '/api/MasterMOM/AttendeColumnUpdate', objAttendeesAtd, this.GetHttpOptions());
  }
  public ApologizedReasonUpdate(objAttendeesAtd: AttendeesAtd) {

    return this.http.post(this.apiURL + '/api/MasterMOM/ApologizedReasonUpdate', objAttendeesAtd, this.GetHttpOptions());
  }

  public addEditAttendeesAtd(objAttendeesAtd: AttendeesAtd) {
    return this.http.post(this.apiURL + '/api/MasterMOM/InsertUpdateAttendeesAtd', objAttendeesAtd, this.GetHttpOptions());
  }

  public updateAttendeesDisplayOrder(obj: AttendeesAtd) {
    return this.http.post(this.apiURL + '/api/MasterMOM/UpdateAttendeesDisplayOrder', obj, this.GetHttpOptions());
  }
  public deleteAttendeesAtd(objAttendeesAtd: AttendeesAtd) {
    return this.http.post(this.apiURL + '/api/MasterMOM/DeleteAttendeesAtd', objAttendeesAtd, this.GetHttpOptions());
  }
  public getUserList(objAttendeesAtd: AttendeesAtd) {
    return this.http.post(this.apiURL + '/api/MasterMOM/getUserListAsync', objAttendeesAtd, this.GetHttpOptions());
  }
  public getDropAtdCategorizeAtd(objAttendeesAtd: AttendeesAtd) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetDropAtdCategorizeAtd', objAttendeesAtd, this.GetHttpOptions());
  }
  public getDropRoleAtd(objAttendeesAtd: AttendeesAtd) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetDropRoleAtd', objAttendeesAtd, this.GetHttpOptions());
  }
  //Fileattachements

  public GetFileList(obj: FileAttachement) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetFileList', obj, this.GetHttpOptions());
  }

  downloadAttachFile(fileType: string, obj: FileAttachement) {
    this.http.post(this.apiURL + '/api/MasterMOM/DownloadAttachFile', obj, {
      responseType: "blob",
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + this.jwtToken()
      })
    })
      .subscribe((res) => {
        var blob = new Blob([res], { type: fileType })
        saveAs(blob, obj.fileName);
      });
  }
  public deleteAttachedFile(objSLA: FileAttachement) {
    return this.http.post(this.apiURL + '/api/MasterMOM/DeleteAttachedFile', objSLA, this.GetHttpOptions());
  }
  public UploadFiles(pageForm: FormData) {
    let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.jwtToken() });
    let options = { headers: headers };
    return this.http.post(this.apiURL + '/api/MasterMOM/UploadFiles', pageForm, {
      responseType: "text",
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + this.jwtToken()
      })
    });
  }

  // Agenda
  public addEditAgenda(objAgenda: AgendaDetails) {
    return this.http.post(this.apiURL + '/api/MasterMOM/InsertUpdateAgendaDetail', objAgenda, this.GetHttpOptions());
  }
  public deleteAgenda(objAgenda: AgendaDetails) {
    return this.http.post(this.apiURL + '/api/MasterMOM/DeleteAgendaDetails', objAgenda, this.GetHttpOptions());
  }
  public getAgendaDetails(objAgenda: AgendaDetails) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetAgendaDetails', objAgenda, this.GetHttpOptions());
  }
  public getMOMDashboard(objMoMDashboard: momDashboard) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetMOMDashboard', objMoMDashboard, this.GetHttpOptions());
  }
  public getActionPointMeetingDetails(objMoMDashboard: momDashboard_MyMeetings) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetActionPointMeetingDetails', objMoMDashboard, this.GetHttpOptions());
  }

  public getSearchList(objMoMDashboard: momDashboard) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetSearchList', objMoMDashboard, this.GetHttpOptions());
  }

  public getDivMeetingList(objMoMDashboard: momDashboard) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetDivMeetingList', objMoMDashboard, this.GetHttpOptions());
  }

  //Usermaster
  public getUserMasters(objusermaster: usermaster) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetUserMasters', objusermaster, this.GetHttpOptions());
  }
  public getFollowUpUsers(objusermaster: usermaster) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetFollowUpUsers', objusermaster, this.GetHttpOptions());
  }

  public uploadProfileImage(objusermaster: user) {
    return this.http.post(this.apiURL + '/api/MasterMOM/uploadProfileImage', objusermaster, this.GetHttpOptions());
  }
  public addEditUserMaster(objusermaster: usermaster) {
    return this._requestTextAPI(this.apiURL + '/api/MasterMOM/InsertUpdateUserMaster', objusermaster);
    // return this.http.post(this.apiURL + '/api/MasterMOM/InsertUpdateUserMaster', objusermaster, this.GetHttpOptions());
  }
  public deleteUserMaster(objusermaster: usermaster) {
    return this.http.post(this.apiURL + '/api/MasterMOM/DeleteUserMaster', objusermaster, this.GetHttpOptions());
  }

  //MeetignAction
  public getMeetingActionAll(objusermaster: meetingAction) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetMeetingActionAll', objusermaster, this.GetHttpOptions());
  }
  public getMeetingActionType(objusermaster: meetingAction_DueToday) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetMeetingActionType', objusermaster, this.GetHttpOptions());
  }
  //Division
  public getDivisions(objDivision: division) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetDivision', objDivision, this.GetHttpOptions());
  }

  public getMeetings(objMeeting: MeetingAppoinments) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetMeetings', objMeeting, this.GetHttpOptions());
  }

  //MeetignAction
  public getResetMeetingActionAll(objusermaster: GenInfoAtd) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetResetMeetingActionAll', objusermaster, this.GetHttpOptions());
  }
  //MeetignAction
  public resetMeetingAction(objusermaster: GenInfoAtd) {
    return this.http.post(this.apiURL + '/api/MasterMOM/ResetMeetingAction', objusermaster, this.GetHttpOptions());
  }

  //Alert
  public getAlertList(objAlert: alert) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetAlertList', objAlert, this.GetHttpOptions());
  }

  public markAsVisited(objAlert: alert) {
    return this._requestTextAPI(this.apiURL + '/api/MasterMOM/MarkAsVisited', objAlert);

  }
  //Search Add
  public addSearchText(obj: momDashboard) {
    return this.http.post(this.apiURL + '/api/MasterMOM/InsertUpdateSearchText', obj, this.GetHttpOptions());
  }
  public getSearchText(objMeetingRoom: momDashboard) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetSearchText', objMeetingRoom, this.GetHttpOptions());
  }


  public resetPassword(objusermaster: usermaster) {
    return this._requestTextAPI(this.apiURL + '/api/MasterMOM/RsetPassword', objusermaster);
  }


  public getDashboardCount(objMeetingRoom: momDashboard) {
    return this.http.post(this.apiURL + '/api/MasterMOM/GetDashboardCount', objMeetingRoom, this.GetHttpOptions());
  }
  public resolveTask(objusermaster: AgendaDetails) {
    return this._requestTextAPI(this.apiURL + '/api/MasterMOM/TaskProgressUpdate', objusermaster);
    //return this.http.post(this.apiURL + '/api/MasterMOM/TaskProgressUpdate', objusermaster, this.GetHttpOptions());
  }
  public updateCacheUser(objusermaster: usermaster) {

    return this._requestTextAPI(this.apiURL + '/api/MasterMOM/UpdateCacheUser', objusermaster);

  }

  public CreatePDF() {
    return this.http.post(this.apiURL + '/api/PdfCreator/GetMOMDashboard', this.GetHttpOptions());
  }


  _requestAPIFileDownload(url: string, body: any) {

    let headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.jwtToken() });
    let options = { headers: headers, responseType: 'blob' as 'json' };
    return this.http.post(url, body, options);
  }

  AttachmentDownload(objfileToUpload: GenInfoAtd) {

    let body = JSON.stringify(objfileToUpload);
    return this._requestAPIFileDownload(this.apiURL + "/api/PdfCreator/PdfDownload", body);
  }
  public pdfCreate(objusermaster: GenInfoAtd) {
    return this._requestTextAPI(this.apiURL + '/api/PdfCreator/CreatePDF', objusermaster);
  }
}
